/** Content styles for column picker modal — matches WarrQueue (hide scrollbar, allow overflow). */
export const getPopupContentStyle = (): Record<string, unknown> => ({
  overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
});
